import once from 'lodash/once';

const HUBSPOT_FORMS_SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/v2.js';

const loadHubSpotForms = (): Promise<void> => {
    return new Promise(resolve => {
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = HUBSPOT_FORMS_SCRIPT_SRC;
        scriptElement.addEventListener('load', () => resolve());
        document.head.appendChild(scriptElement);
    });
};

export default once(loadHubSpotForms);
